/* eslint-disable react/prop-types */
import React from "react";

import { formatDate } from "../../../../../helpers/date";

export const OPEN_SUPPORT_TICKETS_COLUMNS = [
  {
    Header: "Support Ticket Number",
    id: "supportTicket.support_ticket_number",
    accessor: "supportTicket.support_ticket_number",
    minWidth: 150
  },
  {
    Header: "Requestor Company Name",
    id: "supportTicket.requestor_company_name",
    accessor: "supportTicket.requestor_company_name",
    minWidth: 180
  },
  {
    Header: "Requestor Full Name",
    id: "supportTicket.requestor_full_name",
    accessor: "supportTicket.requestor_full_name",
    minWidth: 150
  },
  {
    Header: "Ticket Create Date",
    accessor: "supportTicket.created_on",
    id: "supportTicket.created_on",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : ""),
    minWidth: 150
  },
  {
    Header: "Ticket Last Modified",
    accessor: "supportTicket.modified_on",
    id: "supportTicket.modified_on",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : ""),
    minWidth: 150
  },
  {
    Header: "Ticket Assigned",
    accessor: "user.full_name",
    id: "user.full_name",
    minWidth: 150
  },
  {
    Header: "Call Tech",
    accessor: "user.tech_id",
    id: "user.tech_id",
    minWidth: 150
  },
  {
    Header: "Call Count",
    accessor: "callCount",
    id: "callCount"
  },
  {
    Header: "Stage",
    accessor: "call.stage.label",
    id: "call.stage.label",
    minWidth: 150
  },
  {
    Header: "Completed Date",
    accessor: "call.completed_date",
    id: "call.completed_date",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : ""),
    minWidth: 150
  },
  {
    Header: "Call Create Date",
    accessor: "call.created_on",
    id: "call.created_on",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : ""),
    minWidth: 150
  },
  {
    Header: "Actual Hrs",
    accessor: "call.actual_hrs",
    id: "call.actual_hrs",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Billable Hrs",
    accessor: "call.billable_hrs",
    id: "call.billable_hrs",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Internal Notes",
    accessor: "call.internal_notes",
    id: "call.internal_notes",
    Cell: ({ value }) => <div style={{ whiteSpace: "pre-wrap" }}>{value}</div>,
    minWidth: 350
  },
  {
    Header: "Request Nature Details",
    accessor: "supportTicket.request_nature_details",
    id: "supportTicket.request_nature_details",
    Cell: ({ value }) => <div style={{ whiteSpace: "pre-wrap" }}>{value}</div>,
    minWidth: 350
  }
];
